(() => {
  const initHero = (root) => {
    if (!root || root.dataset.maisonHeroReady === 'true') return;
    root.dataset.maisonHeroReady = 'true';

    const button = root.querySelector('[data-maison-sound]');
    if (!button) return;

    const videos = [...root.querySelectorAll('video')];
    if (!videos.length) return;

    const sync = (muted) => {
      videos.forEach((video) => { video.muted = muted; });
      button.classList.toggle('is-unmuted', !muted);
      button.setAttribute('aria-pressed', String(!muted));
      button.setAttribute('aria-label', muted ? 'Ton einschalten' : 'Ton ausschalten');
    };

    sync(true);
    button.addEventListener('click', () => sync(!videos[0].muted));
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-maison-hero]').forEach(initHero);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
